import React from "react";
import { Wrench, Droplets, Users, Store, Boxes, Route } from "lucide-react";

const ITEMS = [
  { label: "My Day", icon: Route, action: "tab:runsheet", testid: "mobtab-runsheet" },
  { label: "Jobs", icon: Wrench, action: "tab:service", testid: "mobtab-work-orders" },
  { label: "Clients", icon: Users, action: "tab:clients", testid: "mobtab-clients" },
  { label: "POS", icon: Store, action: "tab:pos", testid: "mobtab-pos" },
  { label: "Scan", icon: Boxes, action: "tab:inventory", testid: "mobtab-scan" },
];

export default function MobileTechBar({ onNav }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-slate-200 px-2 py-1.5 flex items-center justify-around md:hidden shadow-[0_-4px_16px_rgba(0,0,0,0.06)]" data-testid="mobile-tech-bar">
      {ITEMS.map((it) => (
        <button key={it.testid} onClick={() => onNav(it.action)} data-testid={it.testid} className="flex flex-col items-center gap-0.5 px-2 py-1 rounded-lg text-slate-500 active:text-sky-700 active:bg-sky-50">
          <it.icon className="h-5 w-5" />
          <span className="text-[10px] font-medium">{it.label}</span>
        </button>
      ))}
    </nav>
  );
}
